import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/notintime.png'
import _imports_1 from '@/assets/unavailable.png'


const _withScopeId = n => (_pushScopeId("data-v-59b29faf"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "unavailable"
}
const _hoisted_2 = {
  key: 0,
  src: _imports_0
}
const _hoisted_3 = {
  key: 1,
  src: _imports_1
}
const _hoisted_4 = { class: "info" }
const _hoisted_5 = {
  key: 0,
  class: "promotion-badge promotion-badge-block"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "button min unavailable-badge"
}
const _hoisted_8 = {
  key: 1,
  class: "button min unavailable-badge"
}
const _hoisted_9 = { class: "product-description" }
const _hoisted_10 = { class: "total" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Subtotal: ")
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = { class: "product-content" }
const _hoisted_16 = { class: "steps" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "step-content" }
const _hoisted_19 = { class: "alt" }
const _hoisted_20 = {
  key: 0,
  class: "indicator-container"
}
const _hoisted_21 = { class: "indicator" }
const _hoisted_22 = {
  id: "items-container",
  class: "options"
}
const _hoisted_23 = {
  key: 0,
  class: "comment"
}
const _hoisted_24 = {
  key: 0,
  class: "number-pad"
}
const _hoisted_25 = { class: "button-container" }
const _hoisted_26 = { class: "controls" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_image_load = _resolveComponent("image-load")!
  const _component_Carousel = _resolveComponent("Carousel")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_ProductItem = _resolveComponent("ProductItem")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_SimpleKeyboard = _resolveComponent("SimpleKeyboard")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    dismissableMask: true,
    baseZIndex: 1,
    modal: true,
    visible: _ctx.context.visible,
    "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.context.visible) = $event)),
    class: "product-dialog",
    onClick: _ctx.dialogClick
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Carousel, {
        class: "product-carousel",
        value: _ctx.context.images
      }, {
        item: _withCtx((image) => [
          (
            !_ctx.context.data?.product?.ProductIsAvailable ||
            _ctx.context.data?.product?.ProductIsNotInTime
          )
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_ctx.context.data?.product?.ProductIsNotInTime)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_2))
                  : (_openBlock(), _createElementBlock("img", _hoisted_3))
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_image_load, {
            class: "img",
            image: image.data,
            "image-class": "cover",
            placeholder: require('@flavor/placeholders/placeholder768x420.png')
          }, null, 8, ["image", "placeholder"])
        ]),
        _: 1
      }, 8, ["value"]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.context.data?.product?.ProductName), 1),
        (_ctx.context.data?.product?.PromotionList?.[0])
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.context.data?.product?.PromotionList?.[0].PromotionName), 1))
          : _createCommentVNode("", true),
        (
          !_ctx.context.data?.product?.ProductIsAvailable ||
          _ctx.context.data?.product?.ProductIsNotInTime
        )
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (!_ctx.context.data?.product?.ProductIsAvailable)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, " Agotado "))
                : (_openBlock(), _createElementBlock("span", _hoisted_8, " No disponible "))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.context.data?.product?.ProductDescription), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_InputNumber, {
          modelValue: _ctx.context.quantity,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.context.quantity) = $event)),
          showButtons: "",
          min: 1,
          max: 99,
          buttonLayout: "horizontal",
          decrementButtonClass: "p-button-danger",
          incrementButtonClass: "p-button-success",
          incrementButtonIcon: "pi pi-plus",
          decrementButtonIcon: "pi pi-minus",
          readonly: true,
          onFocus: _cache[1] || (_cache[1] = ($event: any) => (($event.target as any)?.blur()))
        }, null, 8, ["modelValue"]),
        _createElementVNode("h2", null, [
          _hoisted_11,
          (!_ctx.context.productDiscounted)
            ? (_openBlock(), _createElementBlock("span", _hoisted_12, " $" + _toDisplayString(_ctx.context.productTotal.toFixed(2)), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_13, [
                _createElementVNode("s", null, "$" + _toDisplayString(_ctx.context.productTotal.toFixed(2)), 1),
                _hoisted_14,
                _createTextVNode(" $" + _toDisplayString(_ctx.context.productDiscounted.toFixed(2)), 1)
              ]))
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.context.data?.product?.ModifierList, (modifier) => {
            return (_openBlock(), _createElementBlock("div", {
              key: modifier.ModifierId,
              class: _normalizeClass(["step", {
              active:
                _ctx.context.selectedModifier?.ModifierId === modifier.ModifierId,
            }]),
              onClick: ($event: any) => (_ctx.setSelectedModifier(modifier))
            }, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("p", null, _toDisplayString(modifier.ModifierName), 1),
                _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.getModifierRequirementText(modifier)), 1)
              ]),
              (_ctx.getModifierSelectedQuantity(modifier) > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.getModifierSelectedQuantity(modifier)), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 10, _hoisted_17))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.context.selectedModifier?.ItemList, (item) => {
              return (_openBlock(), _createBlock(_component_ProductItem, {
                ref_for: true,
                ref: (el) => (_ctx.context.items[item.ItemId ?? 0] = el),
                key: item.ItemId,
                item: item,
                modifier: _ctx.context.selectedModifier,
                onItemExpanded: _ctx.itemExpanded
              }, null, 8, ["item", "modifier", "onItemExpanded"]))
            }), 128))
          ])
        ])
      ]),
      (_ctx.context.ProductCommentsEnabled)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createVNode(_component_Textarea, {
              modelValue: _ctx.context.comment,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.context.comment) = $event)),
              placeholder: "Comentarios de la orden",
              rows: "5",
              cols: "30",
              readonly: true,
              onFocus: _cache[3] || (_cache[3] = ($event: any) => (($event.target as any)?.blur?.())),
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.context.showKeyboard = !_ctx.context.showKeyboard))
            }, null, 8, ["modelValue"]),
            (_ctx.context.showKeyboard)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _createVNode(_component_SimpleKeyboard, {
                    onOnChange: _ctx.context.onKeyboardChange,
                    numberRow: true,
                    input: _ctx.context.comment
                  }, null, 8, ["onOnChange", "input"]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", null, [
                      _createElementVNode("button", {
                        class: "last",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.context.showKeyboard = false))
                      }, " Cerrar ")
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("button", {
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.hide())),
          class: "cancel"
        }, "Cancelar"),
        (
          _ctx.context.data?.product?.ProductIsAvailable &&
          !_ctx.context.data?.product?.ProductIsNotInTime
        )
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.sendProduct()))
            }, " Agregar a la orden "))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["visible", "onClick"]))
}